import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  CircularProgress,
  Backdrop,
} from "@material-ui/core";

import Alert from "widgets/alert";
import { setFlagShowDialogCertificate } from "redux/sessionstorage";
import CompanyLogo from "views/administración/UserAccount/CompanyLogo";
import RideLogo from "views/administración/UserAccount/RideLogo";
import { palette } from "configurations/styles/theme";
import apis from "./apis";
import middleware from "configurations/axios";
import { useSelector, useDispatch } from "react-redux";
import { getRUCEmpresa } from "redux/actions/userActions";
import { updateCompanyLogoAction } from "redux/actions/resourcesActions";


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  content: {
    height: "320px"
  },
  circularProgress: {
    margin: "10%",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 999,
    color: palette.primary.main,
  },
}));

const LogoLoading = ({ openDialog, idempresa, onClose }) => {
  const [open, setOpen] = useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();
  const tokenUser = useSelector((state) => state.user.tk);
  const [msgError, setMsg] = useState({ show: false, msg: null, type: null });
  const [updateFileOk, setUpdateFileOk] = useState(false);
  const [openLoader, setOpenLoader] = useState(false);
  const [company, setCompany] = useState(null);
  const updateLogo = (urlLogo) => dispatch(updateCompanyLogoAction(urlLogo));


  useEffect(() => {
    setOpen(openDialog);
    const getCompany = async () => {
      await middleware
        .get(apis.get_company + (tokenUser ? getRUCEmpresa(tokenUser) : "0"))
        .then((response) => {
          if (response.status >= 200 && response.status <= 300) {
            setCompany(response.data);
          }
        })
        .catch((excepcion) => {
          if (excepcion.response) {
            if (excepcion.response.status === 401) {
              //history.push("/");
            }
          } else {
          }
        });
    };
    getCompany();
  }, [openDialog]);

  const handleClose = () => {
    setOpen(false);
    setFlagShowDialogCertificate("N");
    if (typeof onClose === "function") {
      onClose();
    }
  };

  function closeAlert() {
    setMsg({ show: false });
  }

  const handleShowAlert = (alert) => {
    setMsg(alert);
    if (alert.type === "success") {
      setUpdateFileOk(true);
    }
  };

  const handleSubmitLogo = (logo) => {
    setOpenLoader(true);
    updateCompany({ ...company, logo });
  };

  const handleSubmitlogoCafe = (logoCafe) => {
    setOpenLoader(true);
    updateCompany({ ...company, logoCafe });
  };

  const updateCompany = async (newCompany) => {
    await middleware
      .post(apis.update_company, newCompany)
      .then((response) => {
        if (response.status >= 200 && response.status <= 300) {
          setMsg({
            show: true,
            msg: "Logo de la empresa actualizado.",
            type: "success",
          });
          updateLogo(newCompany.logo);
        }
        setCompany(newCompany);
        setOpenLoader(false);
      })
      .catch((exception) => {
        if (exception.response) {
          if (exception.response.status === 400) {
            setMsg({
              show: true,
              msg: "No se pudo actualizar el logo la empresa.",
              type: "error",
            });
          }
        } else {
          setMsg({
            show: true,
            msg:
              "Existen problemas en la red. Contáctese con el administrador del Sistema.",
            type: "error",
          });
        }
        setOpenLoader(false);
      });
  };

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={open}
      onClose={handleClose}
    >
      <DialogTitle  >Cargar Logos </DialogTitle>
      <DialogContent className={classes.content}>
        <Grid container xs={12} spacing={2} className={classes.root} justifyContent="center">
          <Grid item xs={12}>
            <strong>
              Este paso es opcional, si la empresa necesita un logo para el comprobante o tiene un logo como empresa
              se lo puede agregar o actualizar en este apartado.
            </strong>
          </Grid>
          <Grid container justifyContent="center" spacing={2} xs={12}>
            {msgError.show ? (
              <Alert
                tipo={msgError.type}
                mensaje={msgError.msg}
                mesajeSubrayado={null}
                titulo={null}
                mostrar={msgError.show}
                cerrarAlerta={closeAlert}
              />
            ) : null}
            {company ? (
              <Grid justifyContent="center" container xs={12}>
                <Grid item xs={2}></Grid>
                <Grid item xs={5} justifyContent="center">
                  <CompanyLogo
                    title={'Logo de la Empresa'}
                    urlImage={company.logo}
                    onSubmit={handleSubmitLogo}
                    onShowAlert={handleShowAlert}
                  />
                </Grid>
                <Grid item xs={5} justifyContent="center">
                  <RideLogo
                    urlImage={company.logoCafe}
                    onSubmit={handleSubmitlogoCafe}
                    onShowAlert={handleShowAlert}
                  />
                </Grid>
              </Grid>
            ) : (
              <CircularProgress
                className={classes.circularProgress}
                color="secondary"
              />
            )}
            <Backdrop className={classes.backdrop} open={openLoader}>
              <CircularProgress color="inherit" />
            </Backdrop>
          </Grid>
          <Grid container xs={12} justify="center" spacing={3}>
            <Grid xs={12} md={3}>
              <br></br>
              <Button
                fullWidth
                variant="outlined"
                color="secondary"
                onClick={handleClose}
              >
                Cerrar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default LogoLoading;
